import { ChangeDetectionStrategy, Component } from '@angular/core';

import { environment } from 'environments/environment';
import { CoacheeProfileInformationController } from 'presentation/page/profile/coachee-profile/coachee-profile-information/coachee-profile-information.controller';
import { CoacheeProfileController } from 'presentation/page/profile/coachee-profile/coachee-profile.controller';

@Component({
	selector: 'spr-coachee-profile-information',
	templateUrl: './coachee-profile-information.component.html',
	providers: [CoacheeProfileInformationController],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'pb-8',
	},
})
export class CoacheeProfileInformationComponent {
	public picturePlaceholder = environment.profilePlaceholder;

	constructor(
		public controller: CoacheeProfileInformationController,
		public coacheeProfileController: CoacheeProfileController
	) {}
}
